import { render, staticRenderFns } from "./YellowDot.vue?vue&type=template&id=6729c55e&"
import script from "./YellowDot.vue?vue&type=script&lang=js&"
export * from "./YellowDot.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports